import { render, staticRenderFns } from "./gonggao.vue?vue&type=template&id=78a8a93a"
import script from "./gonggao.vue?vue&type=script&lang=js"
export * from "./gonggao.vue?vue&type=script&lang=js"
import style0 from "./gonggao.vue?vue&type=style&index=0&id=78a8a93a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports